const MARGIN_CALL_CALCULATION_TYPES = ['intraday', 'end_of_day', 'ad_hoc'];

export default MARGIN_CALL_CALCULATION_TYPES;
